<template>
  <div>
    <v-dialog v-model="dialog" scrollable max-width="900px">
      <v-card>
        <v-card-title dark class="dialog-header">
          <span>
            {{ action == "Add" ? "Add New " : "Update" }}

            {{
              tab == 1
                ? "Faculty Core Function"
                : tab == 2
                ? "Faculty Strategic Research"
                : tab == 3
                ? "Faculty Strategic Extension and Production"
                : "Professional Development"
            }}</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-col> </v-col>
        <v-card-text style="max-height: 700px">
          <v-form ref="IPCRQlyFormref" @submit.prevent>
            <v-container>
              <v-row class="mt-4">
                <v-col cols="12" class="py-0">
                  <v-textarea
                    v-model="mfo"
                    :rules="[formRules.required]"
                    dense
                    outlined
                    rows="10"
                    required
                    label="Major Final Output"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>
                <v-col cols="3" class="mt-n5">
                  <div
                    class="rounded-lg py-0 px-2"
                    style="border:1px solid grey"
                  >
                    <v-checkbox
                      @change="setCheckbox('e')"
                      v-model="eff_is_rated"
                      label="Efficiency"
                    ></v-checkbox>
                  </div>
                </v-col>
                <v-col cols="9" class="mt-n5">
                  <div
                    class="rounded-lg py-0 px-2 d-flex justify-space-around"
                    style="border:1px solid grey"
                  >
                    <v-checkbox
                      :disabled="!eff_is_rated"
                      v-for="item in eff_rating_scale"
                      :key="item.value"
                      v-model="item.checked"
                      :label="item.label"
                    ></v-checkbox>
                  </div>
                </v-col>
                <v-col cols="3">
                  <div
                    class="rounded-lg py-0 px-2"
                    style="border:1px solid grey"
                  >
                    <v-checkbox
                      @change="setCheckbox('q')"
                      v-model="qly_is_rated"
                      label="Quality"
                    ></v-checkbox>
                  </div>
                </v-col>
                <v-col cols="9">
                  <div
                    class="rounded-lg py-0 px-2 d-flex justify-space-around"
                    style="border:1px solid grey"
                  >
                    <v-checkbox
                      :disabled="!qly_is_rated"
                      v-for="item in qly_rating_scale"
                      :key="item.value"
                      v-model="item.checked"
                      :label="item.label"
                    ></v-checkbox>
                  </div>
                </v-col>
                <v-col cols="3">
                  <div
                    class="rounded-lg py-0 px-2"
                    style="border:1px solid grey"
                  >
                    <v-checkbox
                      @change="setCheckbox('t')"
                      v-model="timeliness_is_rated"
                      label="Timeliness"
                    ></v-checkbox>
                  </div>
                </v-col>
                <v-col cols="9">
                  <div
                    class="rounded-lg py-0 px-2 d-flex justify-space-around"
                    style="border:1px solid grey"
                  >
                    <v-checkbox
                      :disabled="!timeliness_is_rated"
                      v-for="item in timeliness_rating_scale"
                      :key="item.value"
                      v-model="item.checked"
                      :label="item.label"
                    ></v-checkbox>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="close()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Cancel
          </v-btn>
          <v-btn
            v-if="action == 'Add'"
            color="#519043"
            class="white--text"
            @click="add()"
          >
            <v-icon>mdi-check-circle</v-icon>
            Save Details
          </v-btn>
          <v-btn
            v-if="action == 'Update'"
            color="#519043"
            class="white--text"
            @click="update()"
          >
            <v-icon>mdi-check-circle</v-icon>
            Update Details
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    action: null,
    tab: null,
  },
  data() {
    return {
      dialog: false,
      id: null,
      type: null,
      mfo: null,
      eff_is_rated: null,
      qly_is_rated: null,
      timeliness_is_rated: null,
      eff_rating_scale: [
        { value: 5, label: "5", checked: false },
        { value: 4, label: "4", checked: false },
        { value: 3, label: "3", checked: false },
        { value: 2, label: "2", checked: false },
        { value: 1, label: "1", checked: false },
      ],
      qly_rating_scale: [
        { value: 5, label: "5", checked: false },
        { value: 4, label: "4", checked: false },
        { value: 3, label: "3", checked: false },
        { value: 2, label: "2", checked: false },
        { value: 1, label: "1", checked: false },
      ],
      timeliness_rating_scale: [
        { value: 5, label: "5", checked: false },
        { value: 4, label: "4", checked: false },
        { value: 3, label: "3", checked: false },
        { value: 2, label: "2", checked: false },
        { value: 1, label: "1", checked: false },
      ],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        if (data.id != null) {
          console.log(data);
          this.id = data.id;
          this.mfo = data.mfo;
          this.type = data.type;
          this.eff_is_rated = data.eff_is_rated;
          this.qly_is_rated = data.qly_is_rated;
          this.timeliness_is_rated = data.timeliness_is_rated;
          this.eff_rating_scale = data.eff_is_rated
            ? data.eff_rating_scale
            : [
                { value: 5, label: "5", checked: false },
                { value: 4, label: "4", checked: false },
                { value: 3, label: "3", checked: false },
                { value: 2, label: "2", checked: false },
                { value: 1, label: "1", checked: false },
              ];
          this.qly_rating_scale = data.qly_is_rated
            ? data.qly_rating_scale
            : [
                { value: 5, label: "5", checked: false },
                { value: 4, label: "4", checked: false },
                { value: 3, label: "3", checked: false },
                { value: 2, label: "2", checked: false },
                { value: 1, label: "1", checked: false },
              ];
          this.timeliness_rating_scale = data.timeliness_is_rated
            ? data.timeliness_rating_scale
            : [
                { value: 5, label: "5", checked: false },
                { value: 4, label: "4", checked: false },
                { value: 3, label: "3", checked: false },
                { value: 2, label: "2", checked: false },
                { value: 1, label: "1", checked: false },
              ];
        } else {
          this.id = null;
          this.mfo = null;
          this.type = null;
          this.eff_is_rated = false;
          this.qly_is_rated = false;
          this.timeliness_is_rated = false;
          this.eff_rating_scale = [
            { value: 5, label: "5", checked: false },
            { value: 4, label: "4", checked: false },
            { value: 3, label: "3", checked: false },
            { value: 2, label: "2", checked: false },
            { value: 1, label: "1", checked: false },
          ];
          this.qly_rating_scale = [
            { value: 5, label: "5", checked: false },
            { value: 4, label: "4", checked: false },
            { value: 3, label: "3", checked: false },
            { value: 2, label: "2", checked: false },
            { value: 1, label: "1", checked: false },
          ];
          this.timeliness_rating_scale = [
            { value: 5, label: "5", checked: false },
            { value: 4, label: "4", checked: false },
            { value: 3, label: "3", checked: false },
            { value: 2, label: "2", checked: false },
            { value: 1, label: "1", checked: false },
          ];
        }
      },
      deep: true,
    },
  },
  methods: {
    close() {
      this.eventHub.$emit("closeIpcrFacultyStrategicUtilDialog", false);
      this.dialog = false;
    },

    setCheckbox(type) {
      if (type == "e") {
        for (let i = 0; i < this.eff_rating_scale.length; i++) {
          this.eff_rating_scale[i].checked = false;
        }
      }
      if (type == "q") {
        for (let i = 0; i < this.qly_rating_scale.length; i++) {
          this.qly_rating_scale[i].checked = false;
        }
      }
      if (type == "t") {
        for (let i = 0; i < this.timeliness_rating_scale.length; i++) {
          this.timeliness_rating_scale[i].checked = false;
        }
      }
    },
    add() {
      if (this.$refs.IPCRQlyFormref.validate()) {
        let type = "";
        if (this.tab == 1) {
          type = "Core Function";
        } else if (this.tab == 2) {
          type = "Research";
        } else if (this.tab == 3) {
          type = "Extension and Production";
        } else if (this.tab == 4) {
          type = "Professional Development";
        }
        let data = {
          mfo: this.mfo,
          type: type,
          eff_is_rated: this.eff_is_rated ? true : false,
          qly_is_rated: this.qly_is_rated ? true : false,
          timeliness_is_rated: this.timeliness_is_rated ? true : false,
          eff_rating_scale: this.eff_is_rated
            ? JSON.stringify(this.eff_rating_scale)
            : JSON.stringify([]),
          qly_rating_scale: this.qly_is_rated
            ? JSON.stringify(this.qly_rating_scale)
            : JSON.stringify([]),
          timeliness_rating_scale: this.timeliness_is_rated
            ? JSON.stringify(this.timeliness_rating_scale)
            : JSON.stringify([]),
        };
        this.axiosCall(
          "/ipcr-support-util/createFacultyStrategy",
          "POST",
          data
        ).then((res) => {
          if (res.data.status == 201) {
            this.dialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.close();
          } else if (res.data.status == 400) {
            this.dialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },
    update() {
      if (this.$refs.IPCRQlyFormref.validate()) {
        let data = {
          mfo: this.mfo,
          eff_is_rated: this.eff_is_rated ? true : false,
          qly_is_rated: this.qly_is_rated ? true : false,
          timeliness_is_rated: this.timeliness_is_rated ? true : false,
          eff_rating_scale: this.eff_is_rated
            ? JSON.stringify(this.eff_rating_scale)
            : JSON.stringify([]),
          qly_rating_scale: this.qly_is_rated
            ? JSON.stringify(this.qly_rating_scale)
            : JSON.stringify([]),
          timeliness_rating_scale: this.timeliness_is_rated
            ? JSON.stringify(this.timeliness_rating_scale)
            : JSON.stringify([]),
        };
        this.axiosCall(
          "/ipcr-support-util/updateFacultyStrategy/" + this.id,
          "PATCH",
          data
        ).then((res) => {
          if (res.data.status == 200) {
            this.dialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.close();
          } else if (res.data.status == 400) {
            this.dialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },
  },
};
</script>
